/**
 * @file index.tsx
 *
 * @fileoverview Displays a facet box (to be used on the sidebar on a search page for example).
 */

import { cva } from "class-variance-authority";
import { ReactNode } from "react";
import Box from "../../../../02-atoms/07-box";
import styles from "../facet.module.scss";

const facetChildList = cva([styles.facetChildList], {
  variants: {
    isChild: {
      true: styles.facetChildListIsChild,
    },
  },
});

interface FacetChildListProps {
  /**
   * The contens to go into the box.
   */
  children: ReactNode;
  /**
   * The is child flag.
   */
  isChild?: boolean;
}
export function FacetChildList({ children, isChild }: FacetChildListProps) {
  return <div className={facetChildList({ isChild })}>{children}</div>;
}

export interface FacetBoxProps {
  /**
   * The contens to go into the box.
   */
  children: ReactNode;
  /**
   * The label for the facets.
   */
  label: string;
}

/**
 * A facet box contains a list of links inside a box to be used in a
 * sidebar region on the job or resume search pages.
 */
export const FacetBox = ({ children, label }: FacetBoxProps) => {
  return (
    <Box label={label}>
      <div className={styles.facet} data-testid="facet-box">
        {children}
      </div>
    </Box>
  );
};
